var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C13.4477 4 13 3.55228 13 3V2H9V14H10C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16H6C5.44772 16 5 15.5523 5 15C5 14.4477 5.44772 14 6 14H7V2H3V3C3 3.55228 2.55228 4 2 4C1.44772 4 1 3.55228 1 3V1C1 0.447715 1.44772 0 2 0H14C14.5523 0 15 0.447715 15 1V3C15 3.55228 14.5523 4 14 4Z"
  })));
};
export default SvgText;